module.exports = __webpack_public_path__ + "img/quest_icon_0047_pets.e80b4629.png";